import { type DicomPatientName } from '@/lib/dicom/types';

/**
 * Format a DICOM patient name into a single display string, ordered
 * prefix → given → middle → family → suffix. Returns '' when no name is present.
 */
export function formatPatientName(pn: DicomPatientName | undefined): string {
    if (pn) {
        const s: string[] = [];
        if (pn.prefix) {
            s.push(pn.prefix);
        }
        if (pn.givenName) {
            s.push(pn.givenName);
        }
        if (pn.middleName) {
            s.push(pn.middleName);
        }
        if (pn.familyName) {
            s.push(pn.familyName);
        }
        if (pn.suffix) {
            s.push(pn.suffix);
        }
        return s.join(' ');
    }
    return '';
}
